import type { ClockTone } from './draftView'

// The one place a clock tone becomes a colour.
//
// Previously the draft room and the TV board each carried their own map for the
// same three states, and they disagreed: the room used slate/amber/rose while
// the board reused *position* colours (red for crit, amber for warn), so the
// same 8 seconds looked like two different warnings depending on which screen
// you glanced at.
//
// Both surfaces now share one map, deliberately. The board is read across a
// room rather than at arm's length, but the fix for that is size — the board
// sizes its clock at 4.5vw against the room's 42px — not hue. `normal` is
// already near-white and `warn`/`crit` are already the most saturated values in
// the palette, so a separate "brighter" board map would either be identical to
// this one or would push crit somewhere the rest of the app never goes.
//
// If the two surfaces ever do need to diverge, add the second map here rather
// than in a component, so the divergence stays visible in one file.

export const CLOCK_TEXT: Record<ClockTone, string> = {
  normal: 'text-ink-hi',
  warn: 'text-warn',
  crit: 'text-crit',
}

export const CLOCK_BAR: Record<ClockTone, string> = {
  normal: 'bg-ink-faint',
  warn: 'bg-warn',
  crit: 'bg-crit',
}
